module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "custom-class": "bg-wh tx-c box-shadow-none"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.url
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05b45820!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/preview.vue
// module id = 1796
// module chunks = 2